<template>
  <v-row
    v-if="paymentType.value === 'T'"
    dense
    style="margin-bottom: 10px"
  >
    <v-col cols="12">
      <v-expansion-panels style="margin-bottom: 10px">
        <v-expansion-panel>
          <v-expansion-panel-header disable-icon-rotate>
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-cash-register</v-icon>
              <span>
                Fiskalizacija
                <span v-if="fiscalizationConditions && !fiscalizationEnabled" class="caption grey--text">
                  (<span v-if="!fiscalizationConditions.hasCertificate">Nije instaliran certifikat</span><span v-if="!fiscalizationConditions.hasCertificate && !fiscalizationConditions.dateAfter2026">, </span><span v-if="!fiscalizationConditions.dateAfter2026">Omogućeno nakon 01.01.2026.</span>)
                </span>
                <span v-else-if="!hasCertificate" class="caption grey--text">(Nije instaliran certifikat za fiskalizaciju)</span>
              </span>
              <v-spacer></v-spacer>
              <v-chip
                small
                :color="fiscalize ? 'success' : 'warning'"
                text-color="white"
              >
                {{
                  fiscalize ? "Da" : "Ne"
                }}
              </v-chip>
            </div>
            <template v-slot:actions>
              <v-icon>mdi-chevron-down</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense style="margin-top: -1rem">
              <v-col cols="12">
                <v-select
                  :value="fiscalize"
                  @input="$emit('update:fiscalize', $event)"
                  :items="fiscalizationOptions"
                  label="Fiskalizacija"
                  outlined
                  dense
                  :disabled="fiscalizationEnabled !== undefined ? !fiscalizationEnabled : !hasCertificate"
                  @change="$emit('fiscalization-change')"
                  prepend-icon="mdi-receipt"
                  hide-details
                ></v-select>
                <div v-if="fiscalizationConditions && !fiscalizationEnabled" class="caption mt-1">
                  <span>Fiskalizacija dostupna samo kada je </span>
                  <span :class="fiscalizationConditions.hasCertificate ? 'green--text' : 'red--text'">instaliran certifikat</span>
                  <span> i </span>
                  <span :class="fiscalizationConditions.dateAfter2026 ? 'green--text' : 'red--text'">datum nakon 01.01.2026</span>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FiscalizationPanel',
  props: {
    paymentType: {
      type: Object,
      required: true
    },
    fiscalize: {
      type: Boolean,
      required: true
    },
    fiscalizationOptions: {
      type: Array,
      required: true
    },
    hasCertificate: {
      type: Boolean,
      default: true
    },
    fiscalizationConditions: {
      type: Object,
      default: null
    },
    fiscalizationEnabled: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>
